import React, { ButtonHTMLAttributes } from 'react';
import styled, { css } from 'styled-components';

import { styles } from '../../styles';
import { Spin } from '../spin';

const types = {
  primary: css`
    ${styles.bg.primary}
    color: white;
  `,
  light: css`
    ${styles.bg.borderLight};
  `,
  danger: css`
    ${styles.bg.danger};
    color: white;
  `,
};

const sizes = {
  sm: css`
    padding: 2px 8px;
  `,
  smd: css`
    padding: 6px 12px;
  `,
  md: css`
    padding: 12px 16px;
  `,
};

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  t?: keyof typeof types | null;
  size?: keyof typeof sizes;
};

export const ButtonBase = styled.button<ButtonProps>`
  border: none;
  border-radius: ${(props) => props.theme.borderRadius.md};
  cursor: pointer;
  transition: all 0.3s;
  font-weight: bold;
  :hover {
    filter: brightness(0.9);
  }
  :active {
    filter: brightness(1.03);
  }

  ${(props) => types[props.t]}
  ${(props) => sizes[props.size || 'md']}
  :disabled {
    background-color: ${(props) => props.theme.color.border};
    cursor: not-allowed;
  }
`;

export const Button = React.forwardRef<
  HTMLButtonElement,
  ButtonProps & { loading?: boolean }
>(({ loading, disabled, children, ...props }, ref) => {
  return (
    <ButtonBase ref={ref} {...props} disabled={loading || disabled}>
      {loading && <Spin size={10} style={{ marginRight: 10 }} />}
      {children}
    </ButtonBase>
  );
});

Button.displayName = 'Button';
